import { ResponsibleMedicalRecordRepository } from '../repositories/ResponsibleMedicalRecordRepository'

export function SetResponsibleMedicalRecordExpiredUseCase(
  repository: ResponsibleMedicalRecordRepository
) {
  return async (params: { id: string }) => {
    return await repository.setResponsibleMedicalRecordExpired(params)
  }
}
